import { tableSchema } from '@nozbe/watermelondb'

export const milkQualitiesSchema = tableSchema({
  name: 'milkQualities',
  columns: [
    { name: 'milkQualityId', type: 'string' },
    { name: 'dairyFarmId', type: 'string' },
    { name: 'ccs', type: 'number' },
    { name: 'ctb', type: 'number' },
    { name: 'ccsLimit', type: 'number' },
    { name: 'ctbLimit', type: 'number' },
    { name: 'organizationId', type: 'string' },
    { name: 'manual', type: 'boolean' },
    { name: 'userDocument', type: 'string' },
    { name: 'date', type: 'string' },
    { name: 'protein', type: 'string' },
    { name: 'fat', type: 'string' },
    { name: 'proteinLimit', type: 'string' },
    { name: 'fatLimit', type: 'string' },
    { name: 'userStateRegistrationId', type: 'string' },
    { name: 'nul', type: 'string' },
    { name: 'lactose', type: 'string' },
    { name: 'groupedItems', type: 'string' },
    { name: 'createdAt', type: 'string' },
    { name: 'updatedAt', type: 'string' }
  ]
})